// extracted by mini-css-extract-plugin
export var childrenContainer = "_ca-0";
export var virtualScrollArea = "_ca-1";